import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { BsModalService } from 'ngx-bootstrap';
import { BankTransactionApi, UploadApi } from '../../../../../assets/js/lb-sdk';
import { ActivatedRoute } from '@angular/router';
import { Event } from '../../../../interfaces';
import { finalize } from 'rxjs/operators';
import { BANK_TRANSACTION_STATUS } from '../../../../enums';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-bank-transaction',
  templateUrl: './bank-transaction.component.html',
  styleUrls: ['./bank-transaction.component.css']
})
export class BankTransactionComponent extends BasicList {
  BANK_TRANSACTION_STATUS: typeof BANK_TRANSACTION_STATUS = BANK_TRANSACTION_STATUS;
  bankTransaction;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'orderReference', placeholder: 'ReferenceNumber' },
      { name: 'payer', placeholder: 'Payer' },
      { name: 'handler', placeholder: 'Handler' },
      { name: 'bank', placeholder: 'Bank' },
      { name: 'branch', placeholder: 'Branch' },
      { name: 'status', placeholder: 'Status', options: BANK_TRANSACTION_STATUS },
      { name: 'remarks', placeholder: 'Remarks' }
    ],
    filters: {}
  };

  constructor(
    private bankTransactionApi: BankTransactionApi,
    private uploadApi: UploadApi,
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.route.paramMap
      .subscribe((params: any) => {
        this.params = {
          where: {
            uploadId: params.params.id
          },
          order: 'orderIndex ASC'
        };
      });
    this.settings = {
      createComponent: undefined,
      api: this.bankTransactionApi,
      ModalService: this.modalService
    };
    this.pagination = {
      page: 1,
      limit: 100,
      total: 0
    };
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'initialized':
        this.loading.bankTransaction = true;
        this.clearErrors();
        this.uploadApi
          .findById(this.params.where.uploadId)
          .pipe(finalize(() => {
            this.loading.bankTransaction = false;
          }))
          .subscribe(
            bankTransaction => {
              this.bankTransaction = bankTransaction;
            },
            error => {
              this.errors.bankTransaction = error.message || 'Failed to load bank transaction details';
            }
          );
        this.getList();
        break;
    }
  }

  process(id: string) {
    this.clearErrors();
    this.loading.process = true;
    this.bankTransactionApi
      .execute(id)
      .pipe(finalize(() => {
        this.loading.process = false;
      }))
      .subscribe(
        bankTransaction => {
          this.toast.success('Bank Transaction successfully processed', 'Process');
          this.getList();
        },
        error => {
          this.errors.process = 'Failed to process bank transaction';
        }
      );
  }

  discard(id: string) {
    this.clearErrors();
    this.loading.process = true;
    this.bankTransactionApi
      .discard(id)
      .pipe(finalize(() => {
        this.loading.process = false;
      }))
      .subscribe(
        bankTransaction => {
          this.toast.success('Bank Transaction successfully discarded', 'Discard');
          this.getList();
        },
        error => {
          this.errors.process = 'Failed to discard bank transaction';
        }
      );
  }
}
